module.exports = __webpack_public_path__ + "img/jwgl-jcsj-role.e7370f39.png";